import { useLocale, useTranslations } from 'next-intl';
import { ReviewItem } from './ReviewItem';
import { ReviewsModal } from './ReviewsModal';
import { StarBigIcon } from '@/component/Icons/StarBigIcon';
import { useLoadableQuery } from '@apollo/client';
import { SearchListingDetailReviewsQuery } from '@/query';
import { useParams } from 'next/navigation';
import { useEffect, useRef } from 'react';

const LIMIT = 40;

export const Reviews = ({ reviews, rating, setIsOpen, isOpen }) => {
  const t = useTranslations();
  const locale = useLocale();
  const count = reviews?.metadata?.totalCount || 0;

  const params = useParams();

  const [loadReviews, queryRef, { fetchMore }] = useLoadableQuery(
    SearchListingDetailReviewsQuery,
    { errorPolicy: 'ignore', fetchPolicy: 'no-cache' }
  );

  const loadedPages = useRef([1]);

  useEffect(() => {
    if (isOpen && !queryRef) {
      loadReviews({
        slug: params.slug,
        page: 1,
        limit: LIMIT,
        locale,
      });
    }
  }, [isOpen, loadReviews, params.slug, queryRef]);

  return (
    <div className="pt-8 pb-10 flex flex-col gap-6 lg:pr-8 border-t border-slate-300">
      <div className="text-slate-700 text-lg font-semibold">
        {t('apartment.rating.title')}
      </div>
      <div className="text-primary-700 text-5xl flex gap-1 items-center">
        <StarBigIcon />
        {rating}
      </div>
      <div className="grid sm:grid-cols-2 gap-x-4 gap-y-[46px]">
        {reviews?.collection?.map((item, i) => (
          <ReviewItem key={i} id={i + 1} {...item} openModal={setIsOpen} />
        ))}
      </div>
      {!!count && (
        <button
          onClick={() => setIsOpen(true)}
          className="btn btn-second self-start"
          type="button"
          data-testid="room-reviews-show-more-button"
        >
          {t('show-all')} {count}&nbsp;
          <span className="lowercase">{t('apartment.rating.sub-title')}</span>
        </button>
      )}
      {isOpen && queryRef && (
        <ReviewsModal
          show={isOpen}
          close={() => setIsOpen(false)}
          reviews={reviews}
          rating={rating}
          count={count}
          queryRef={queryRef}
          fetchMore={fetchMore}
          loadedPages={loadedPages.current}
          LIMIT={LIMIT}
        />
      )}
    </div>
  );
};
